import moment from 'moment'
import {issueConstants} from '../constants/issue.constants'

const initialState = {
  customFields: [],
  issues: [],
  count: 0,
  isLoading: false,
  shouldUpdate: false,
  startDate: moment().subtract(6, 'years').startOf('day'),
  endDate: moment().endOf('day')
}

export function IssueReducer (state = initialState, action) {
  switch (action.type) {
    case (issueConstants.GETALL_REQUEST): {
      const updatedState = Object.assign({}, state, {isLoading: true, shouldUpdate: false})
      return updatedState
    }
    case (issueConstants.GETALL_SUCCESS): {
      const successState = Object.assign({}, state, {...action.payload, isLoading: false})
      return successState
    }
    case (issueConstants.GETALL_FAILURE): {
      const updatedState = Object.assign({}, state, {isLoading: false})
      return updatedState
    }
    case (issueConstants.START_DATE_CHANGE): {
      const updatedState = Object.assign({}, state, {startDate: action.date})
      return updatedState
    }
    case (issueConstants.END_DATE_CHANGE): {
      const updatedState = Object.assign({}, state, {endDate: action.date})
      return updatedState
    }
    case (issueConstants.DELETE_ISSUE_REQUEST): {
      const updatedState = Object.assign({}, state, {isLoading: true})
      return updatedState
    }
    case (issueConstants.DELETE_ISSUE_FAILURE): {
      const updatedState = Object.assign({}, state, {isLoading: false})
      return updatedState
    }
    case (issueConstants.DELETE_ISSUE_SUCCESS): {
      const updatedState = Object.assign({}, state, {isLoading: false, shouldUpdate: true})
      return updatedState
    }
    case (issueConstants.UPDATE_ISSUE_REQUEST): {
      const updatedEditingIssue = Object.assign({}, state.editingIssue, {
        isLoading: true
      })
      const updatedState = Object.assign({}, state, {
        editingIssue: updatedEditingIssue
      })
      return updatedState
    }
    case (issueConstants.UPDATE_ISSUE_SUCCESS): {
      const updatedState = Object.assign({}, state, {
        shouldUpdate: true,
        editingIssue: initialState.editingIssue
      })
      return updatedState
    }
    case (issueConstants.UPDATE_ISSUE_FAILURE): {
      const updatedEditingIssue = Object.assign({}, state.editingIssue, {
        isLoading: false,
        error: true
      })
      const updatedState = Object.assign({}, state, {
        editingIssue: updatedEditingIssue
      })
      return updatedState
    }
    case (issueConstants.UPDATE_ISSUE_STATUS_SUCCESS): {
      const updatedState = Object.assign({}, state, {
        shouldUpdate: true
      })
      return updatedState
    }
    default:
      const start = state.startDate ? state.startDate.startOf('day') : null
      const end = state.endDate ? state.endDate.endOf('day') : null
      const updatedState = Object.assign({}, state, {
        startDate: start,
        endDate: end
      })
      return updatedState
  }
}



// WEBPACK FOOTER //
// ./src/reducers/IssueReducer.js